import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-79d8ab96"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "latex-style-panel" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"flex":"2"} }, "颜色：", -1))
const _hoisted_5 = { class: "row" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"flex":"2"} }, "粗细：", -1))

import { onUnmounted, Ref, ref } from 'vue'
import { storeToRefs } from 'pinia'
import { useMainStore, useSlidesStore } from '@/store'
import { PPTLatexElement } from '@/types/slides'
import emitter, { EmitterEvents } from '@/utils/emitter'
import useHistorySnapshot from '@/hooks/useHistorySnapshot'

import ColorButton from '../common/ColorButton.vue'
import LaTeXEditor from '@/components/LaTeXEditor/index.vue'
import ColorPicker from '@/components/ColorPicker/index.vue'
import {
  InputNumber,
  Divider,
  Button,
  Popover,
  Modal,
} from 'ant-design-vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'LatexStylePanel',
  setup(__props) {

const slidesStore = useSlidesStore()
const { handleElement } = storeToRefs(useMainStore())

const handleLatexElement = handleElement as Ref<PPTLatexElement>

const latexEditorVisible = ref(false)

const { addHistorySnapshot } = useHistorySnapshot()

const updateLatex = (props: Partial<PPTLatexElement>) => {
  if (!handleElement.value) return
  slidesStore.updateElement({ id: handleElement.value.id, props })
  addHistorySnapshot()
}

const updateLatexData = (data: { path: string; latex: string; w: number; h: number; }) => {
  updateLatex({
    path: data.path,
    latex: data.latex,
    width: data.w,
    height: data.h,
    viewBox: [data.w, data.h],
  })
}

const openLatexEditor = () => latexEditorVisible.value = true

emitter.on(EmitterEvents.OPEN_LATEX_EDITOR, openLatexEditor)
onUnmounted(() => {
  emitter.off(EmitterEvents.OPEN_LATEX_EDITOR, openLatexEditor)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(Button), {
        style: {"flex":"1"},
        onClick: _cache[0] || (_cache[0] = ($event: any) => (latexEditorVisible.value = true))
      }, {
        default: _withCtx(() => [
          _createTextVNode("编辑 LaTeX")
        ]),
        _: 1
      })
    ]),
    _createVNode(_unref(Divider)),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createVNode(_unref(Popover), { trigger: "click" }, {
        content: _withCtx(() => [
          _createVNode(ColorPicker, {
            modelValue: _unref(handleLatexElement).color,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = value => updateLatex({ color: value }))
          }, null, 8, ["modelValue"])
        ]),
        default: _withCtx(() => [
          _createVNode(ColorButton, {
            color: _unref(handleLatexElement).color,
            style: {"flex":"3"}
          }, null, 8, ["color"])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _createVNode(_unref(InputNumber), {
        min: 1,
        max: 3,
        value: _unref(handleLatexElement).strokeWidth,
        onChange: _cache[2] || (_cache[2] = value => updateLatex({ strokeWidth: value as number })),
        style: {"flex":"3"}
      }, null, 8, ["value"])
    ]),
    _createVNode(_unref(Modal), {
      visible: latexEditorVisible.value,
      "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((latexEditorVisible).value = $event)),
      footer: null,
      centered: "",
      width: 880,
      destroyOnClose: ""
    }, {
      default: _withCtx(() => [
        _createVNode(LaTeXEditor, {
          value: _unref(handleLatexElement).latex,
          onClose: _cache[3] || (_cache[3] = ($event: any) => (latexEditorVisible.value = false)),
          onUpdate: _cache[4] || (_cache[4] = data => { updateLatexData(data); latexEditorVisible.value = false })
        }, null, 8, ["value"])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}
}

})